import { Col, Row } from "antd";
import styles from "./Reviews.module.css";
import person1 from "../../../assets/avatar-1.png";
import person2 from "../../../assets/avatar-2.png";
import person3 from "../../../assets/avatar-3.png";
import person4 from "../../../assets/avatar-4.png";
import dummy from "../../../assets/dummy.png";
import {
  SubmitButton,
  TextComponent,
  TextareaField,
} from "../../../components";
import { RiExternalLinkFill } from "react-icons/ri";
import { useEffect, useState } from "react";
import Modal from "../../../components/modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import { ReviewMiddleware } from "../../../Store/Middlewares/ReviewMiddleware";

const Reviews = () => {
  const ReviewsList = useSelector((state) => state.ReviewReducer.Reviews);
  const [reviewModal, setReviewModal] = useState(false);
  const [reviewRes, setReviewRes] = useState();
  const [itemCurr, setItemCurr] = useState();
  const [loading, setloading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    getReviews();
  }, []);

  const getReviews = () => {
    dispatch(ReviewMiddleware.getReviews())
      .then((res) => {
        setloading(false);
      })
      .catch((err) => {
        setloading(false);
      });
  };

  const submitReviewRes = () => {
    let data = {
      review_id: itemCurr?.id,
      client_id: itemCurr?.user_id,
      feedback: reviewRes,
    };
    dispatch(ReviewMiddleware.submitResponse(data))
      .then((res) => {
        setReviewRes("");
        setReviewModal(false);
      })
      .catch((err) => {
        setloading(false);
      });
  };
  return (
    <>
      <Row>
        <Col xs={24} className={styles.mainCol}>
          {ReviewsList?.map((review) => {
            console.log("reviewwwwwwwwwww", review);
            const status = review?.type?.toLowerCase();
            const statusClass =
              status === "complaint"
                ? styles.complaintText
                : status === "suggestion"
                ? styles.suggestionText
                : styles.reviewStatusText;
            return (
              <Row gutter={24} className={styles.reviewRow}>
                <Col xs={24} lg={16}>
                  <Row gutter={16} className={styles.imgRow}>
                    <Col>
                      <img
                        src={review.user_image ? review.user_image : dummy}
                        alt="Person"
                        className={styles.avatarImg}
                      />
                    </Col>
                    <Col>
                      <TextComponent textClass={styles.reviewName}>
                        {review?.user_name}
                      </TextComponent>
                      <TextComponent textClass={styles.reviewText}>
                        {review?.review}
                      </TextComponent>
                    </Col>
                  </Row>
                </Col>
                <Col xs={24} lg={8}>
                  <Row className={styles.btnRow}>
                    <Col>
                      <TextComponent
                        textClass={`${styles.statusText} ${statusClass}`}
                      >
                        {review?.type}
                      </TextComponent>
                    </Col>
                    <Col>
                      {!review?.is_already_response && (
                        <RiExternalLinkFill
                          size={30}
                          color="var(--primary-color)"
                          className={styles.reviewLink}
                          onClick={() => {
                            setItemCurr(review);
                            setReviewModal(true);
                          }}
                        />
                      )}
                    </Col>
                  </Row>
                </Col>
              </Row>
            );
          })}
        </Col>
      </Row>
      <Modal
        isModalOpen={reviewModal}
        setIsModalOpen={setReviewModal}
        closable={true}
        wideModal={true}
        className={styles.reviewModal}
      >
        <TextComponent textClass={styles.modalHeading}>Reply</TextComponent>
        <TextareaField
          styles={styles.textareaContainer}
          rows={10}
          textareaClass={styles.textarea}
          value={reviewRes}
          onChange={(e) => setReviewRes(e.target.value)}
          placeholder="Attended a wedding recently where they had a 'memory lane' with photos of the couple through the years – it was such a heartwarming addition to the celebration."
        />
        <SubmitButton
          title="Submit"
          btnClass={styles.modalBtn}
          onClick={submitReviewRes}
        />
      </Modal>
    </>
  );
};

export default Reviews;
